export default {
  title: 'Studio (V2)',
  description: 'Build and manage the restaurant website with the new Website Studio.',
  retry: 'Try again',
  deleted: 'Project deleted.',
  errors: {
    load: 'The Studio (V2) project could not be loaded.',
    create: 'The project could not be created. Please try again.',
    delete: 'The project could not be deleted. Please try again.',
  },
  EmptyState: {
    title: 'No Studio (V2) project yet',
    description: 'Create a project to build the website in the new Website Studio. Studio (V1) stays as it is.',
    description_no_access: 'An onboarding manager can create the project for this brand.',
    create: 'Create project',
  },
  ProjectCard: {
    unnamed: 'Unnamed project',
    edit: 'Edit in Studio',
    delete: 'Delete',
    open: 'Open',
    no_domain: 'No domain yet',
    fields: {
      uuid: 'UUID',
      domain: 'Domain',
      websites: 'Websites',
    },
    delete_confirm: {
      title: 'Delete this project?',
      description: 'This removes the Studio (V2) project and its websites. You can create a new one later.',
      ok: 'Delete',
      cancel: 'Cancel',
    },
  },
};
